<div *ngIf="message!=null">
  <h5 class="loading-msg">{{message}}</h5>
</div>

<div *ngIf="!determinate">
  <mat-progress-bar *ngIf="bar" mode="indeterminate"></mat-progress-bar>
  <div *ngIf="!bar" class="progress-section" style="padding: {{padding}}px 0 {{padding}}px 0;">
    <mat-spinner [diameter]="size" mode="indeterminate"></mat-spinner>
  </div>
</div>

<div *ngIf="determinate">
  <mat-progress-bar *ngIf="bar" mode="determinate" [value]="determinateValue"></mat-progress-bar>
  <div *ngIf="!bar" class="progress-section" style="padding: {{padding}}px 0 {{padding}}px 0;">
    <mat-spinner [diameter]="size" mode="determinate" [value]="determinateValue"></mat-spinner>
  </div>
</div>
